import { Controller } from "stimulus"

export default class extends Controller {

  toggle() {
    const toggleClass = 'mobile-nav--open'
    const menu = document.querySelector('.mobile-nav--black')
    const logo = document.querySelector('.header__logo-img')
    if (menu) {
      this.element.checked ? menu.classList.add(toggleClass) : menu.classList.remove(toggleClass)
    }

    if (this.element.checked) {
      logo.style = 'filter: invert(1) !important'
    } else {
      logo.style = 'filter: invert(1)'
    }
  }
}
